import type { FaireProductEntity } from "../../entity_types/product";

export const p_bnavs899b8: FaireProductEntity = {
  token: "p_bnavs899b8",
  type: "product",
  name: "Fluffernutter - New England Friendship & Love Greeting Card",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/e06be71301d16975486a4b569b733d31789318dde1f67b6ac0c6e6efa96f730d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa30786220b42a038c9370e9af7d15b9f0725acce87a2e9636a7442bf2521e58.png",
    "https://cdn.faire.com/fastly/611721cb5670e642febde254fb7855521f0989716c031c2562cc70e159ee1a19.jpeg"
  ],
  priceDollars: 3,
  description: "For the fluffernutter lovers! Features a marshmallow fluff jar and a Teddie's peanut butter jar with the words \"you're the peanut butter to my fluff\" underneath.\n\nSmall-batch greeting card created, printed, and packaged by hand in Boston, MA. Perfect for gift shops and boutiques seeking unique, locally-made stationery.\n\nDetails:\n• Standard A2 greeting card size: 4.25\" x 5.5\"\n• Blank inside for personalization\n• Includes coordinating envelope\n• Comes in a protective clear sleeve, ready for display\n\nEach card is created by Sarah in her Boston home studio, offering customers unique designs with a personal, handcrafted touch.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:52.644Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
